/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { serviceRouteList } from 'routes/Constant';
import ApiUtil from '../utils/ApiUtil';
import { requestApiUrls } from 'constants/apiEndPoints';
import QueryParamsBuilder from 'components/helpers/commonFunctions/QueryParamsBuilder';

const viewAllPlanChangeRequests = async (page: number, size: number,
    sortBy: string, sortOrder: string, searchValue: string, filters: unknown): Promise<unknown> => await
        new Promise((resolve, reject) => {

            let url = QueryParamsBuilder({ baseUrl: requestApiUrls.viewAllPlanChangeRequestsUrl, page, size, sortBy, sortOrder, searchValue });
            const filterParams = new URLSearchParams();
            if (filters) {
                if (filters.startDate) {
                    filterParams.append('startDate', `${filters.startDate} 00:00:00 +00:00`);
                }

                if (filters.endDate) {
                    filterParams.append('endDate', `${filters.endDate} 23:59:59 +00:00`);
                }

                if (filters.status) {
                    const status = filters.status || '';
                    filterParams.append('status', status);
                }
            }

            if (filterParams.toString()) {
                url += `&${filterParams.toString()}`;
            }

            ApiUtil.getWithToken(url)
                .then(plans => {
                    resolve(plans);
                })
                .catch(error => {
                    reject(error);
                });
        });

const updatePlanChangeRequestStatus = async (requestInfo: Record<string, string>): Promise<unknown> =>
    await
        new Promise((resolve, reject) => {
            const { requestId, userId, status, requestedRetirementPlanId, requestedPensionPlanId } = requestInfo;
            ApiUtil.postWithToken(`${requestApiUrls.updatePlanChangeRequestStatusUrl}/${requestId}`, { userId, status, requestedRetirementPlanId, requestedPensionPlanId })
                .then(plans => {
                    resolve(plans);
                })
                .catch(error => {
                    reject(error);
                });
        });

const viewAllWithdrawalRequests = async (page: number, size: number, sortBy: string, sortOrder: string, searchValue: string, filters: unknown): Promise<unknown> => await
    new Promise((resolve, reject) => {
        let url = QueryParamsBuilder({ baseUrl: requestApiUrls.viewAllWithdrawalRequestsUrl, page, size, sortBy, sortOrder, searchValue });

        const filterParams = new URLSearchParams();
        if (filters) {
            if (filters.startDate) {
                filterParams.append('startDate', filters.startDate);
            }

            if (filters.endDate) {
                filterParams.append('endDate', filters.endDate);
            }

            if (filters.status) {
                const status = filters.status || '';
                filterParams.append('status', status);
            }
        }

        if (filterParams.toString()) {
            url += `&${filterParams.toString()}`;
        }
        ApiUtil.getWithToken(url)
            .then(withdrawals => {
                resolve(withdrawals);
            })
            .catch(error => {
                reject(error);
            });
    });

const viewWithdrawalRequestById = async (requestId: number): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.postWithToken(`${requestApiUrls.viewWithdrawalRequestByIdUrl}/${requestId}`)
            .then(request => {
                resolve(request);
            })
            .catch(error => {
                reject(error);
            });
    })

const updateWithdrawalRequest = async (requestInfo: Record<string, string | number>): Promise<unknown> =>
    await
        new Promise((resolve, reject) => {
            const { userId, requestId } = requestInfo;
            ApiUtil.putWithToken(`${requestApiUrls.updateWithdrawalRequestUrl}/${userId}/${requestId}`, requestInfo)
                .then(request => {
                    resolve(request);
                })
                .catch(error => {
                    reject(error);
                });
        });


const addNewTransferRequest = async (requestInfo: Record<string, string | number>): Promise<unknown> =>
    await
        new Promise((resolve, reject) => {
            ApiUtil.postWithToken(`${requestApiUrls.addNewTransferRequestUrl}`, requestInfo)
                .then(request => {
                    resolve(request);
                })
                .catch(error => {
                    reject(error);
                });
        });

const updateTransferRequest = async (requestInfo: Record<string, string | number>): Promise<unknown> =>
    await
        new Promise((resolve, reject) => {
            const { requestId } = requestInfo;
            ApiUtil.putWithToken(`${requestApiUrls.updateTransferRequestUrl}/${requestId}`, requestInfo)
                .then(request => {
                    resolve(request);
                })
                .catch(error => {
                    reject(error);
                });
        });

const viewTransferRequests = async (page: number, size: number, sortBy: string, sortOrder: string, searchValue: string, filters: unknown): Promise<unknown> =>
    await
        new Promise((resolve, reject) => {
            let url = QueryParamsBuilder({ baseUrl: requestApiUrls.viewTransferRequestsUrl, page, size, sortBy, sortOrder, searchValue });
            const filterParams = new URLSearchParams();
            if (filters) {
                if (filters.startDate) {
                    filterParams.append('startDate', `${filters.startDate} 00:00:00 +00:00`);
                }

                if (filters.endDate) {
                    filterParams.append('endDate', `${filters.endDate} 23:59:59 +00:00`);
                }

                if (filters.status) {
                    const status = filters.status || '';
                    filterParams.append('status', status);
                }

                if (filters.transferType) {
                    const transferType = filters.transferType || '';
                    filterParams.append('transferType', transferType);
                }
            }

            if (filterParams.toString()) {
                url += `&${filterParams.toString()}`;
            }

            ApiUtil.getWithToken(url)
                .then(plans => {
                    resolve(plans);
                })
                .catch(error => {
                    reject(error);
                });
        });

const viewTransferOutRequests = async (
    page: number,
    size: number,
    sortBy: string,
    sortOrder: string,
    searchValue: string,
    filters: unknown,
): Promise<unknown> =>
    await new Promise((resolve, reject) => {
        let url = QueryParamsBuilder({
            baseUrl: requestApiUrls.viewTransferOutRequestsUrl,
            page,
            size,
            sortBy,
            sortOrder,
            searchValue,
        });

        const filterParams = new URLSearchParams();

        if (filters) {
            if (filters.startDate) {
                filterParams.append('startDate', filters.startDate);
            }

            if (filters.endDate) {
                filterParams.append('endDate', filters.endDate);
            }
        }

        if (filterParams.toString()) {
            url += `&${filterParams.toString()}`;
        }

        ApiUtil.getWithToken(url)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });

const viewTransferRequestByUserId = async (userId: number): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.getWithToken(`${requestApiUrls.viewTransferRequestByUserIdUrl}/${userId}`)
            .then(request => {
                resolve(request);
            })
            .catch(error => {
                reject(error);
            });
    });
const marketDataPriceByConid = async (conId: number): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.postWithToken(`${requestApiUrls.marketDataPriceByConidUrl}/${conId}`)
            .then(request => {
                resolve(request);
            })
            .catch(error => {
                reject(error);
            });
    })

const OnfidoDocsImages = async (imageUrl: string): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.postWithToken(serviceRouteList.onfidoDocDetails, { imageUrl })
            .then(request => {
                resolve(request);
            })
            .catch(error => {
                reject(error);
            });
    })

const onfidoLiveImages = async (imageUrl: string): Promise<unknown> => await
    new Promise((resolve, reject) => {
        ApiUtil.postWithToken(serviceRouteList.onfidoLiveImages, { imageUrl })
            .then(request => {
                resolve(request);
            })
            .catch(error => {
                reject(error);
            });
    })


const onfidoAplicationById = async (documentId: string): Promise<unknown> => await
    new Promise((resolve, reject) => {
        const onfidoDocDetails: string = serviceRouteList.onfidoDocDetails
        ApiUtil.postWithToken(`${onfidoDocDetails}${documentId}`)
            .then(request => {
                resolve(request);
            })
            .catch(error => {
                reject(error);
            });
    })


const getUserWithdrawalAmountByPertantage = async (userId: number | string, percentage: number): Promise<unknown> => await
    new Promise((resolve, reject) => {
        const userFundDetails: string = serviceRouteList.userFundDetails
        ApiUtil.getWithToken(`${userFundDetails}${userId}/${percentage}`)
            .then(request => {
                resolve(request);
            })
            .catch(error => {
                reject(error);
            });
    });

const getAllUserPlanRequests = async (userId: string, page: number, size: number): Promise<unknown> => await new Promise((resolve, reject) => {
    ApiUtil.getWithToken(`${requestApiUrls.getAllUserPlanRequestsUrl}/${userId}?page=${page}&size=${size}`)
        .then(request => {
            resolve(request);
        })
        .catch(error => {
            reject(error);
        });
});

const getAllUserWithdrawalRequests = async (userId: string, page: number, size: number): Promise<unknown> => await new Promise((resolve, reject) => {
    ApiUtil.getWithToken(`${requestApiUrls.getAllUserWithdrawalRequestsUrl}/${userId}?page=${page}&size=${size}`)
        .then(request => {
            resolve(request);
        })
        .catch(error => {
            reject(error);
        });
});

export {
    updatePlanChangeRequestStatus,
    viewAllPlanChangeRequests,
    viewAllWithdrawalRequests,
    viewWithdrawalRequestById,
    updateWithdrawalRequest,
    addNewTransferRequest,
    updateTransferRequest,
    viewTransferRequests,
    viewTransferOutRequests,
    viewTransferRequestByUserId,
    marketDataPriceByConid,
    OnfidoDocsImages,
    onfidoLiveImages,
    onfidoAplicationById,
    getUserWithdrawalAmountByPertantage,
    getAllUserPlanRequests,
    getAllUserWithdrawalRequests
}